<script>
import axios from "axios";

import helper from "./mixins/helper";

export default {
    mixins: [helper],
    components: {
    },
    props: {
    },
    data() {
        return {
            allowRequest: true
        }
    },
    created() {
        /*window.addEventListener('beforeunload', (event) => {
            this.saveInDB(this.$store.state.cart);
        });*/
    },
    beforeMount() {
    },
    mounted() {
    },
    computed: {
        count: function() {
            if (this.isset(this.$store.state.cart.data)) {
                return this.$store.state.cart.data.length;
            } else {
                return 0;
            } 
        },
        fullPrice: function () {
            let answer = 0;
            if (this.isset(this.$store.state.cart)) {
                let cart = this.$store.state.cart.data;
                let info = this.$store.state.cart.products;
                if (info) {
                    for (var i = 0; i < info.length; i++) {
                        for (var b = 0; b < cart.length; b++) {
                            if (cart[b].product == info[i].id) {
                                let price = info[i].price_finaly * cart[b].count;
                                answer = answer + price;
                            }
                        }
                    }
                }
            }
            return answer;
        },
        sortCartProducts: function () {
            let answer = [];
            if (this.isset(this.$store.state.cart)) {
                let cart = this.$store.state.cart.data;
                let info = this.$store.state.cart.products;
                if (info) {
                    for (var i = 0; i < cart.length; i++) {
                        for (var b = 0; b < info.length; b++) {
                            if (cart[i].product == info[b].id) {
                                answer.push(info[b]);
                            }
                        }
                    }
                }
            }
            return answer.reverse();
        },
        ViewedProducts: function () {
            if (this.isset(this.$store.state.cart.data) && this.isset(this.$store.state.viewed_products)) {
                let cartProducts = this.$store.state.cart.data;
                //let viewedProducts = this.jsonParse(globalVariables.viewedProducts);
                let viewedProducts = this.$store.state.viewed_products;
                // Check if exist on cart delete
                let ids = [];
                cartProducts.forEach(cart_prod => {
                    ids.push(cart_prod.product);
                });

                let array = [];
                for (var i = 0; i < viewedProducts.length; i++) {
                    if (i <= 5) {
                        if (!ids.includes(viewedProducts[i].id)) {
                            array.push(viewedProducts[i]);
                        }
                    }
                }

                // Sort by cookies
                if (this.getCookie('viewed_products')) {
                    let answer = [];
                    let cookies = this.jsonParse(this.getCookie('viewed_products'));
                    for (var i = 0; i < cookies.length; i++) {
                        for (var b = 0; b < array.length; b++) {
                            if (cookies[i] == array[b].id) {
                                answer.push(array[b]);
                            }
                        }
                    }
                    array = answer;
                }

                return array;
            }
        }
    },
    methods: {
        on_product_notifictation(product) {
            let notifications = [];
            if (this.delivery_only_kiev(product)) {
                notifications.push({ title: this.trans('cart.delivery_only_kiev'), text: this.trans('cart.delivery_only_kiev_text')});
            }
            if (this.cargo_branch(product)) {
                notifications.push({ title: this.trans('cart.cargo_branch'), text: this.trans('cart.cargo_branch_text')});
            }
            // Return
            if (notifications.length > 0) {
                return notifications;
            }
        },
        delivery_only_kiev(product) {
            if (product.delivery_only_kiev) {
                return true;
            }
        },
        cargo_branch(product) {
            if (product.cargo_branch) {
                return true;
            }
        },
        remaining(id, current_count) {
            let count = 0;
            let remaining = this.$store.state.cart.products.filter(obj => obj.id == id)[0].remaining;
            remaining.forEach(element => {
                if (element.warehouse.available_to_buy) {
                    count = count + element.quantity;
                }
            });
            if (current_count == count) {
                return false;
            } else {
                return true;
            }
        },
        allow() {
            this.allowRequest = true;
        },
        getCount(id) {
            let array = this.$store.state.cart.data;
            for (var i = 0; i < array.length; i++) {
                if (array[i].product == id) {
                    return array[i].count;
                }
            }  
        },
        changeCount(product, action) {
            if (this.allowRequest) {
                clearTimeout(window.send);
                let array = this.$store.state.cart.data;
                for (var i = 0; i < array.length; i++) {
                    if (array[i].product == product) {
                        if (action == 'plus') {
                            if (this.remaining(array[i].product, array[i].count)) {
                                array[i].count++;
                            }
                        } else {
                            if (array[i].count > 1) {
                                array[i].count--;
                            }
                        }
                    }
                }
                this.$store.commit('cart_saving', true);
                window.send = setTimeout(()=>{
                    this.allowRequest = false;
                    this.saveInDB(this.$store.state.cart);
                }, 800);
            }
        },
        deleteItem(product) {
            if (this.allowRequest) {
                clearTimeout(window.send);
                let array = this.$store.state.cart.data;
                for (var i = 0; i < array.length; i++) {
                    if (array[i].product == product) {
                        array.splice(i, 1)
                    }
                }
                this.$store.commit('cart_saving', true);
                window.send = setTimeout(()=>{
                    this.allowRequest = false;
                    this.saveInDB(this.$store.state.cart);
                }, 800);
            }
        },
        saveInDB(cartObj) {
            axios({
                method: "post",
                url: window.globalVariables.locale + "/update_cart",
                data: {
                    cart: cartObj
                },
                config: {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                }
            })
            .then(response => {
                this.$store.commit('cart_saving', false);
                this.$store.commit('cart_add', response.data[0]);
                this.allow();
            })
            .catch(error => {
                console.log(error);
                this.allow();
            });
        }
    }
}
</script>
